import classNames from "classnames";
import { useMemo } from "react";

export type OptionSelect = {
    value: string,
    label: string,
}

export function getValueInputSelect(value: string | undefined, options: OptionSelect[]) {
    const option = options.find(o => o.value === value);
    return option?.value ?? "";
}

export function InputSelect({ label, value, options, error, onChange = () => { }, disabled = false, placeholder = "Select ..." }: { label?: string, value?: string | undefined, options: OptionSelect[], error?: string | undefined, onChange?: (value: string) => void, disabled?: boolean, placeholder?: string }) {
    const valueSelect = useMemo(() => getValueInputSelect(value, options), [value, options]);
    
    return (
        <div>
            {label && label?.length > 0 && (
                <label className="block mb-2 text-sm font-medium text-gray-900">{label}</label>
            )}
            <select
                className={
                    classNames(
                        "no-icon-select select_icon border text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-1 focus:border w-full ps-2.5 pe-10 py-2.5",
                        {
                            "bg-gray-50 border-gray-300 focus:border-blue-500 focus:ring-blue-500": !disabled && !error,
                            "bg-gray-50 border-red-500 focus:border-red-500 focus:ring-red-500": !disabled && error,
                            "bg-gray-200 border-gray-300 focus:border-blue-500 focus:ring-blue-500 cursor-not-allowed": disabled,
                        },
                    )
                }
                value={valueSelect}
                onChange={(e) => onChange(e.target.value ?? "")}
                disabled={disabled}
            >
                <option disabled value="">{placeholder}</option>
                {options.map(o => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                ))}
            </select>
            {error && (
                <p className="mt-1.5 text-xs text-red-600 dark:text-red-500">{error}</p>
            )}
        </div>
    );
}